import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Button,
  Box,
  makeStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import { useReactToPrint } from "react-to-print";
import {
  applyAddressChoice,
  getAddressOptionsForAccount,
} from "../../utils/accountAddressPrint";

const styles = {
  wrapper: {
    width: 376,
    height: 188,
  },
  barcodeWrapper: {
    marginTop: "5px",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    "& p": {
      fontSize: 5,
      margin: 0,
    },
    "& svg": {
      width: "100px",
      height: 33,
      marginTop: "-7px",
    },
  },
  text: {
    fontSize: "18px!important",
    fontWeight: "700!important",
  },
  senderText: {
    fontSize: "18px!important",
  },
};

const useStyles = makeStyles(styles);

function AddressLabelPrintBlock({ account, sender, classes }) {
  return (
    <div className={classes.wrapper}>
      <div className={classes.barcodeWrapper}>
        <p className={classes.text}>To, {account.name || account.accountName || ""}</p>
        <p className={classes.text}>{account.address || account.accountAddress || ""}</p>
        <p className={classes.text}>
          {account.city || ""}, {account.state || ""}
        </p>
        <p className={classes.text}>M: {account.mobile}</p>
        <p className={classes.text}>Pincode: {account.pin || account.pincode || ""}</p>
        {sender && (sender.name || sender.address) && (
          <p className={classes.senderText}>
            From : {sender.name || ""}, {sender.address || ""}
          </p>
        )}
      </div>
    </div>
  );
}

const AccountAddress = (props) => {
  const classes = useStyles();
  const componentRef = useRef();

  let account;
  let sender;
  if (props.location && props.location.state) {
    ({ account, sender } = props.location.state);
  } else if (props.account && props.sender) {
    account = props.account;
    sender = props.sender;
  } else {
    account = props.account || {};
    sender = props.sender || {};
  }

  const [addressChoice, setAddressChoice] = useState("billing");

  const options = useMemo(() => getAddressOptionsForAccount(account), [account]);

  const displayAccount = useMemo(
    () => applyAddressChoice(account, addressChoice),
    [account, addressChoice]
  );

  useEffect(() => {
    setAddressChoice("billing");
  }, [account?._id, account?.shippingAddress]);

  useEffect(() => {
    const keys = new Set(options.map((o) => o.key));
    if (!keys.has(addressChoice)) {
      setAddressChoice("billing");
    }
  }, [options, addressChoice]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "",
    pageStyle: ` 
    @media print {  
        @page {
            size: 333px 200px;
            margin: 0mm;
            padding: 0mm;
        } 
    }`,
  });

  const selector =
    options.length > 1 ? (
      <FormControl fullWidth margin="dense" style={{ marginBottom: 12 }}>
        <InputLabel id="address-label-select">Address to print</InputLabel>
        <Select
          labelId="address-label-select"
          value={addressChoice}
          onChange={(e) => setAddressChoice(e.target.value)}
        >
          {options.map((o) => (
            <MenuItem key={o.key} value={o.key}>
              {o.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    ) : null;

  if (props.open !== undefined) {
    return (
      <Dialog
        open={props.open}
        onClose={props.close}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Print Address Label</DialogTitle>
        <DialogContent>
          {selector}
          <Box ref={componentRef} style={{ padding: 14 }}>
            <AddressLabelPrintBlock
              account={displayAccount}
              sender={sender}
              classes={classes}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={props.close} color="secondary">
            Close
          </Button>
          <Button color="primary" onClick={handlePrint}>
            Print Address
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  return (
    <div>
      {selector}
      <Button color="primary" onClick={handlePrint}>
        Print Address
      </Button>
      <Box ref={componentRef} style={{ padding: 14 }}>
        <AddressLabelPrintBlock
          account={displayAccount}
          sender={sender}
          classes={classes}
        />
      </Box>
    </div>
  );
};

export default AccountAddress;
